const source = 'podsDataTable'

function downloadMultipodsPdf () {

  const keys = Object.keys(this.filtered.items).filter((s) => s == source)
  if(keys.length > 0){
    const ids = this.filtered.items[source]

    this.$eventBus.emit('show-dialog-page', {
      page: 'pods-multipods',
      title: 'Multipods',
      data: ids,
      maximize: false,
    })
  } 
}

export default {
  'bindTo': 'this',
  'method': downloadMultipodsPdf,
}
